/* Sveikatos Taškas – paprastas slankiklis. Privati sveikatostaskas.lt nuosavybė. */
if (!customElements.get('st-slider')) {
  customElements.define('st-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-st-track]');
      this.prev = this.querySelector('[data-st-prev]');
      this.next = this.querySelector('[data-st-next]');
      this.dots = this.querySelector('[data-st-dots]');
      if (!this.track) return;
      this.items = Array.from(this.track.children);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => { window.requestAnimationFrame(() => this.update()); }, { passive: true });
      window.addEventListener('resize', () => this.build());
      this.build();
    }
    perView() {
      if (!this.items.length) return 1;
      return Math.max(1, Math.round(this.track.clientWidth / this.items[0].getBoundingClientRect().width));
    }
    pages() { return Math.max(1, this.items.length - this.perView() + 1); }
    current() {
      const w = this.items[0] ? this.items[0].getBoundingClientRect().width : 1;
      const gap = this.items[1] ? this.items[1].offsetLeft - this.items[0].offsetLeft - w : 0;
      return Math.round(this.track.scrollLeft / (w + gap));
    }
    go(dir) {
      const target = Math.min(this.pages() - 1, Math.max(0, this.current() + dir));
      this.scrollToIndex(target);
    }
    scrollToIndex(i) {
      const item = this.items[i];
      if (item) this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
    }
    build() {
      const pages = this.pages();
      this.classList.toggle('st-slider--static', pages <= 1);
      if (this.dots) {
        this.dots.innerHTML = '';
        if (pages > 1) {
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'st-slider__dot';
            b.setAttribute('aria-label', String(i + 1));
            b.addEventListener('click', () => this.scrollToIndex(i));
            this.dots.appendChild(b);
          }
        }
      }
      this.update();
    }
    update() {
      const c = this.current();
      if (this.dots) Array.from(this.dots.children).forEach((d, i) => d.classList.toggle('is-active', i === c));
      if (this.prev) this.prev.disabled = c <= 0;
      if (this.next) this.next.disabled = c >= this.pages() - 1;
    }
  });
}
